import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=485e1627&scoped=true&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=485e1627&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e1627",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485e1627')) {
      api.createRecord('485e1627', component.options)
    } else {
      api.reload('485e1627', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=485e1627&scoped=true&", function () {
      api.rerender('485e1627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Checkbox.vue"
export default component.exports